import React from 'react';

export default class Policies extends React.Component {

    render = () => (
        <div className="genericBody">
            <h2><u>Politique d'utilisation des données personnelles</u></h2>
            <h3><u>Type de données récoltées :</u></h3>
            <span>Il est en notre devoir de vous informer que cette application récolte vos données personnelles suivantes:</span>
            <li>Nom d'utilisateur</li>
            <li>Adresse mail</li>
            <li>Localisation</li>
            <li>Âge</li>
            <h3><u>Utilisation des données :</u></h3>
            <span>Ces informations sont recueillies pour personnaliser votre expérience utilisateur et pour effectuer des statistiques par région et par âge afin de vous proposer de meilleurs produits plus tard et de vous orienter vers d'autres création d'Orca Corp qui seraient susceptibles de vous intéresser.</span>
            <h3><u>Exclusivité des données :</u></h3>
            <span>Nous nous réservons l'utilisation exclusive de ces données et nous engageons à ne pas les divulguer à des sociétés tierses ni à des organismes gouvernementaux.</span>
            <h3><u>Changements dans nos politiques de confidentialité :</u></h3>
            <span>Toutes modifications éventuelles dans nos politiques d'utilisation de vos données personnelles vous seront communiquées à l'avance</span>
        </div>
    )

}